/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAutomus = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.642 4C19.6 4 22 6.415 22 9.394l-.007.277a5.402 5.402 0 0 1-2.169 4.063c.099.41.154.838.154 1.278 0 2.978-2.4 5.392-5.359 5.392H7.36C4.398 20.404 2 17.99 2 15.012c0-1.78.855-3.358 2.175-4.34a5.44 5.44 0 0 1-.153-1.278C4.022 6.415 6.422 4 9.381 4zM5.307 12.895a2.959 2.959 0 0 0-.887 2.117 2.948 2.948 0 0 0 2.938 2.957h7.261a2.948 2.948 0 0 0 2.923-3.258 5.322 5.322 0 0 1-.886.075H9.381a5.331 5.331 0 0 1-4.074-1.891zm2.797-.841a2.91 2.91 0 0 0 1.277.297h6.516a2.908 2.908 0 0 0-1.278-.297zM9.38 6.436a2.949 2.949 0 0 0-2.924 3.258 5.36 5.36 0 0 1 .901-.076h7.261c1.63 0 3.09.734 4.072 1.89a2.956 2.956 0 0 0 .89-2.114 2.949 2.949 0 0 0-2.94-2.958z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAutomus as Automus };
